import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Grid } from '@material-ui/core';
import snaphunt from '@snaphunt/snaphunt-theme';
import PubSub from 'pubsub-js';

import { useBreakpoints } from '$app/common/utils/mediaQueries';
import RegistrationTopic from '$app/modules/registrationPage/topics/RegistrationPage.topic';
import NavSideMenu from './NavSideMenu';

const MobileNav = () => {
  const [activeSidemenu, setActiveSidemenu] = useState(false);

  const handleClickOutside = () => {
    setActiveSidemenu(false);
  };

  const closeSideMenu = () => {
    setActiveSidemenu(false);
  };

  return (
    <div
      css={{
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        {/* eslint-disable-next-line */}
        <div css={{ display: 'flex', alignItems: 'center' }}>
          <div
            role="button"
            tabIndex={-1}
            className={`hamburger ${activeSidemenu ? 'active' : ''}`}
            onClick={() => setActiveSidemenu(curr => !curr)}
            onKeyDown={() => {}}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
      <NavSideMenu
        active={activeSidemenu}
        onOverlayClick={handleClickOutside}
        closeSideMenu={closeSideMenu}
      />
    </div>
  );
};

// Header Component for the pages
const Header = () => {
  const { isXsDown, isSmDown } = useBreakpoints();

  return (
    <div css={{ maxWidth: 1200, margin: '0 auto' }}>
      <Grid container spacing={0}>
        <Grid item xs={8} sm={8} md={6} lg={6}>
          <nav
            css={{
              display: 'flex',
              height: 70,
              marginLeft: isSmDown ? 25 : 0,
            }}
          >
            <div>
              <img
                src="https://images.snaphunt.com/assets/images/tesa-logo-01.svg"
                alt="CompanyLogo"
                css={{
                  width: isSmDown ? 120 : 200,
                  height: 70,
                  marginRight: isXsDown ? 0 : 30,
                }}
              />
            </div>
            <div
              css={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: 70,
                alignItems: 'center',
              }}
            >
              {isXsDown ? null : (
                <div
                  css={{
                    margin: isXsDown ? '0 10px 0 0' : '0 40px 0 0',
                    cursor: 'pointer',
                  }}
                >
                  <Link
                    to="/"
                    css={{
                      color: snaphunt.palette.text.color.black,
                      '&:hover': {
                        color: '#6C2D8A',
                      },
                    }}
                  >
                    Home
                  </Link>
                </div>
              )}
              {isXsDown ? null : (
                <button
                  type="button"
                  onClick={() => PubSub.publish(RegistrationTopic.OPEN)}
                  css={{
                    color: snaphunt.palette.text.color.black,
                    '&:hover': {
                      color: '#6C2D8A',
                    },
                    margin: isXsDown ? '0 10px 0 0' : '0 40px 0 0',
                    cursor: 'pointer',
                    background: 'transparent',
                    border: 'none',
                  }}
                >
                  Jobs
                </button>
              )}
              {isXsDown ? null : (
                <div
                  css={{
                    margin: isXsDown ? '0 10px 0 0' : '0 40px 0 0',
                    cursor: 'pointer',
                  }}
                >
                  <Link
                    to="/events"
                    css={{
                      color: snaphunt.palette.text.color.black,
                      '&:hover': {
                        color: '#6C2D8A',
                      },
                    }}
                  >
                    Events
                  </Link>
                </div>
              )}
              {isXsDown ? null : (
                <a
                  css={{
                    color: snaphunt.palette.text.color.black,
                    '&:hover': {
                      color: '#6C2D8A',
                    },
                    margin: isXsDown ? '0 10px 0 0' : '0 40px 0 0',
                    cursor: 'pointer',
                  }}
                  href="https://www.imda.gov.sg/imtalent/programmes/skills-framework-for-ict"
                  target="_blank"
                  rel="noreferrer"
                >
                  Resources
                </a>
              )}
            </div>
          </nav>
        </Grid>
        {isSmDown && (
          <div
            css={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
            }}
          >
            <MobileNav />
          </div>
        )}
      </Grid>
    </div>
  );
};

export default Header;
